import { isEmpty, isNull, isUndefined, values } from "lodash";
import {
  CLEAR_SYS_GUARD_TABLE_DATA,
  CREATE_JIRA_INCIDENT,
  FETCH_CHATBOT_RESPONSE,
  FETCH_SYS_GUARD_DATA_SOURCE,
  FETCH_ALL_SYS_GUARD_DATA_SOURCES,
  fetchApplicationAnomaliesCount,
  fetchApplicationBasedUserCounts,
  fetchCityCoordinates,
  fetchLocationAnomaliesCount,
  fetchLocationBasedApplications,
  fetchSidePopupData,
  fetchSysGuardApplicationAPI,
  fetchSysGuardApplicationBasedAnomalies,
  fetchSysGuardApplicationBasedUsers,
  fetchSysGuardLocationBasedAnomalies,
  fetchSysGuardLocationBasedApplications,
  fetchSysGuardLocationBasedUsers,
  fetchSysGuardLocationData,
  fetchSysGuardUserAnomaliesApi,
  fetchSysGuardUserApplicationApi,
  fetchSysGuardUserDeviceApi,
  fetchSysGuardUserDistinctLocations,
  fetchSysGuardUserLocationApi,
  fetchSysGuardUsersAPI,
  fetchUserAnomaliesSidePopupData,
  fetchUserBasedDevicesCount,
  GET_EXPANDED_USERS_DASHBOARD_DATA,
  GET_SYS_GUARD_APPLICATION,
  GET_SYS_GUARD_CITY_DATA,
  GET_SYS_GUARD_DISTINCT_LOCATIONS,
  GET_SYS_GUARD_HEADER_DATA,
  GET_SYS_GUARD_LOCATION,
  GET_SYS_GUARD_POPUP_DATA,
  GET_SYS_GUARD_SIDE_POPUP_DATA,
  GET_SYS_GUARD_USERS,
  GET_UNIQUE_USER_LIST,
  getChatbotResponseAPI,
  getDatasourceWithType,
  getAllSysGuardDataSources,
  getSysGuardApplicationNames,
  getUniqueUsersList,
  NlpDummyData,
  OPEN_SYS_GUARD_SNACKBAR,
  REPORT_INCIDENT_FAILED,
  REPORT_INCIDENT_SUCCESSFUL,
  reportToJira,
  SAVE_CHAT_BOT_CHAT,
  SAVE_SYS_GUARD_COMMENT,
  saveChatBotAPI,
  SET_CHATBOT_LOADER,
  SET_CHATBOT_RESPONSE,
  SET_EXPANDED_USERS_DASHBOARD_DATA,
  SET_REPORT_INCIDENT_DETAILS,
  SET_SYS_GUARD_ALERT_COMMENT,
  SET_SYS_GUARD_APPLICATION_NAMES,
  SET_SYS_GUARD_CITY_DATA,
  SET_SYS_GUARD_COUNTRY_NAMES,
  SET_SYS_GUARD_DATASOURCE,
  SET_ALL_SYS_GUARD_DATASOURCES,
  SET_SYS_GUARD_DISTINCT_LOCATIONS,
  SET_SYS_GUARD_HEADER_DATA,
  SET_SYS_GUARD_PAGE_LOADER,
  SET_SYS_GUARD_POPUP_DATA,
  SET_SYS_GUARD_POPUP_TOTAL_ELEMENTS,
  SET_SYS_GUARD_SIDE_POPUP_DATA,
  SET_SYS_GUARD_TABLE_DATA,
  SET_SYS_GUARD_TABLE_LOADER,
  SET_TOTAL_ELEMENTS,
  SET_UNIQUE_USER_LIST,
  SYS_GUARD_APPLICATION_NAMES_LIST,
  SYS_GUARD_COUNTRIES_LIST,
} from "../sysGuardConstants";
import { GET_COMPLIANCE_STATE_DATA } from "../../Compliance/complianceConstants";
import { getAxiosHeaders, getService } from "../../../library/RestAPI";
import {
  getCubejsApi,
  redirectToLogin,
} from "../../../components/common/Dashboard/cubejs-util";
import { maskUsername } from "../SysGuardCommonComp";
import { generateHeatmapData } from "../../../components/common/Dashboard/utils";
import {
  ENTRA,
  GOOGLEWORKSPACE,
  SAVE_ALERT_COMMENT_URL,
  SET_ALERT_DRAWER_PAGE_LOADER,
} from "../../../redux/constants/constants";

const heatmap = { rows: 8, columns: 6 }; //For short view of User Heat Map
const heatmapExpanded = { rows: 22, columns: 17 }; //For expanded view of User Heat Map
const { takeEvery, put, select, call } = require("redux-saga/effects");

function* fetchSysGuardHeaderData(action) {
  const { loc } = action.payload;
  const dataSourcesById = yield select(
    (state) => state.SysGuardReducer.sysGuardDataSource
  );
  
  // Get all data sources and find the first available one
  const dataSources = Object.values(dataSourcesById);
  const entraSource = dataSources.find(ds => ds?.typeCode === ENTRA);
  const googleSource = dataSources.find(ds => ds?.typeCode === GOOGLEWORKSPACE);
  
  const sysGuardData =
    !isNull(entraSource) && !isEmpty(entraSource) ? entraSource : googleSource;
  const dataSourceId = sysGuardData?.id;
  const dataSourceType = sysGuardData?.type?.code;
  const isGoogleWorkspace = dataSourceType === "GOOGLEWORKSPACE";
  const sysData = yield select((state) => state.SysGuardReducer);
  const { fromTimeStamp, toTimeStamp, selectedDatasourceID } = sysData;
  const cubejs = getCubejsApi();
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });
  const locationHeaderDataQuery = {
    measures: [
      "SysguardLocationCount.totalUniqueLocationCount",
      "SysguardLocationCount.alertUniqueLocationCount",
    ],
    filters: [
      {
        member: "SysguardLocationCount.eventTime",
        operator: "gte",
        values: [`${fromTimeStamp}`],
      },
      {
        member: "SysguardLocationCount.eventTime",
        operator: "lte",
        values: [`${toTimeStamp}`],
      },
      {
        member: "SysguardLocationCount.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };
  const locationChartQuery = {
    dimensions: [
      "SysguardLocationCount.latitude",
      "SysguardLocationCount.longitude",
      "SysguardLocationCount.category",
    ],
    order: {
      "SysguardLocationCount.totalUniqueLocationCount": "desc",
    },
    filters: [
      {
        member: "SysguardLocationCount.eventTime",
        operator: "gte",
        values: [`${fromTimeStamp}`],
      },
      {
        member: "SysguardLocationCount.eventTime",
        operator: "lte",
        values: [`${toTimeStamp}`],
      },
      {
        member: "SysguardLocationCount.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };
  const userChartQuery = {
    dimensions: ["SysguardUserChart.name", "SysguardUserChart.alertCount"],
    order: {
      "SysguardUserChart.username": "asc",
    },
    limit: 50,
    filters: [
      {
        member: "SysguardUserChart.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };
  const applicationQuery = {
    measures: [
      "SysguardApplicationCount.totalApplication",
      "SysguardApplicationCount.suspiciousApplication",
    ],
    filters: [
      {
        member: "SysguardApplicationCount.time",
        operator: "gte",
        values: [`${fromTimeStamp}`],
      },
      {
        member: "SysguardApplicationCount.time",
        operator: "lte",
        values: [`${toTimeStamp}`],
      },
      {
        member: "SysguardApplicationCount.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };
  const applicationChartQuery = {
    dimensions: [
      "SysguardApplicationCount.appDetails",
      "SysguardApplicationCount.alertCount",
    ],
    order: {
      "SysguardApplicationCount.alertCount": "desc",
    },
    filters: [
      {
        member: "SysguardApplicationCount.time",
        operator: "gte",
        values: [`${fromTimeStamp}`],
      },
      {
        member: "SysguardApplicationCount.time",
        operator: "lte",
        values: [`${toTimeStamp}`],
      },
      {
        member: "SysguardApplicationCount.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };
  const deviceHeaderData = {
    measures: [
      "SysguardDeviceCount.totalDevices",
      "SysguardDeviceCount.suspiciousDevice",
    ],
    filters: [
      {
        member: "SysguardDeviceCount.timeColumn",
        operator: "gte",
        values: [`${fromTimeStamp}`],
      },
      {
        member: "SysguardDeviceCount.timeColumn",
        operator: "lte",
        values: [`${toTimeStamp}`],
      },
      {
        member: "SysguardDeviceCount.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };
  const totalDeviceCountWorkSpace = {
    measures: ["AccessMonitoringDevice.deviceCount"],
    filters: [
      {
        member: "AccessMonitoringDevice.dataSourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
      {
        member: "AccessMonitoringDevice.lastSyncTimeStamp",
        operator: "gte",
        values: [`${fromTimeStamp}`],
      },
      {
        member: "AccessMonitoringDevice.lastSyncTimeStamp",
        operator: "lte",
        values: [`${toTimeStamp}`],
      },
    ],
  };
  const usersWithMoreThanTwoDevices = {
    measures: ["UserWithMoreThanTwoDevices.userCount"],
    filters: [
      {
        member: "UserWithMoreThanTwoDevices.dataSourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };
  const MFAHeaderData = {
    measures: ["SysguardMFACount.enabled", "SysguardMFACount.total"],
    order: {
      "SysguardMFACount.enabled": "asc",
    },
    filters: [
      {
        member: "SysguardMFACount.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };
  const suspiciousHeaderData = {
    measures: [
      "SysguardSuspiciousUsers.totalUsers",
      "SysguardSuspiciousUsers.suspiciousUser",
    ],
    filters: [
      {
        member: "SysguardSuspiciousUsers.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };

  try {
    const locationData = yield cubejs.load(locationHeaderDataQuery);
    const applicationData = yield cubejs.load(applicationQuery);
    const locationChartData = yield cubejs.load(locationChartQuery);
    const userChartData = yield cubejs.load(userChartQuery);
    const applicationChartData = yield cubejs.load(applicationChartQuery);
    const deviceData = yield cubejs.load(
      isGoogleWorkspace ? totalDeviceCountWorkSpace : deviceHeaderData
    );
    const userWithMoreThanTwoDevices = yield cubejs.load(
      usersWithMoreThanTwoDevices
    );
    const MFAData = yield cubejs.load(MFAHeaderData);
    const suspiciousData = yield cubejs.load(suspiciousHeaderData);

    const location = locationData.rawData();
    const application = applicationData.rawData();
    const locationChart = locationChartData.rawData();
    const userChart = userChartData.rawData();
    const applicationChart = applicationChartData.rawData();
    const device = deviceData.rawData();
    const MFA = MFAData.rawData();
    const suspicious = suspiciousData.rawData();
    const userWithMoreThanTwoDevicesCount =
      userWithMoreThanTwoDevices.rawData();
    const { heatmapData, heatmapDetails } = generateHeatmapData(
      userChart,
      heatmap,
      "SysguardUserChart.alertCount",
      "SysguardUserChart.name"
    );

    const getDeviceData = (device, type) => {
      switch (type) {
        case "ENTRA":
          return {
            totalCount: parseInt(device[0]["SysguardDeviceCount.totalDevices"]),
            alertCount: parseInt(
              device[0]["SysguardDeviceCount.suspiciousDevice"]
            ),
          };
        case "GOOGLEWORKSPACE":
          return {
            totalCount: parseInt(
              device[0]["AccessMonitoringDevice.deviceCount"]
            ),
            alertCount: parseInt(
              device[0]["AccessMonitoringDevice.totalUsers"]
            ),
          };
        default:
          return {
            totalCount: parseInt(device[0]["SysguardDeviceCount.totalDevices"]),
            alertCount: parseInt(
              device[0]["SysguardDeviceCount.suspiciousDevice"]
            ),
          };
      }
    };
    const systemGuardData = {
      location: {
        totalCount: parseInt(
          location[0]["SysguardLocationCount.totalUniqueLocationCount"]
        ),
        alertCount: parseInt(
          location[0]["SysguardLocationCount.alertUniqueLocationCount"]
        ),
      },
      application: {
        totalCount: parseInt(
          application[0]["SysguardApplicationCount.totalApplication"]
        ),
        alertCount: parseInt(
          application[0]["SysguardApplicationCount.suspiciousApplication"]
        ),
      },
      locationChart: locationChart
        .map((e) => {
          const lat = parseFloat(e["SysguardLocationCount.latitude"]);
          const lng = parseFloat(e["SysguardLocationCount.longitude"]);

          if (isNaN(lat) || isNaN(lng)) {
            return null; // skip invalid entries
          }

          return {
            position: [lat, lng],
            label: "",
            category: e["SysguardLocationCount.category"],
          };
        })
        .filter(Boolean),
      userChart: { heatmapData, heatmapDetails },
      applicationChart: applicationChart.map((e) => {
        return {
          appDetails: e["SysguardApplicationCount.appDetails"],
          alertCount: e["SysguardApplicationCount.alertCount"],
        };
      }),
      device: getDeviceData(device, dataSourceType),
      userWithMoreThanTwoDevices: {
        totalCount: parseInt(
          userWithMoreThanTwoDevicesCount[0][
            "UserWithMoreThanTwoDevices.userCount"
          ]
        ),
      },
      mfa: {
        enabledCount: parseInt(MFA[0]["SysguardMFACount.enabled"]),
        totalCount: parseInt(MFA[0]["SysguardMFACount.total"]),
      },
      suspicious: {
        totalCount: parseInt(
          suspicious[0]["SysguardSuspiciousUsers.totalUsers"]
        ),
        alertCount: parseInt(
          suspicious[0]["SysguardSuspiciousUsers.suspiciousUser"]
        ),
      },
    };

    yield put({ type: SET_SYS_GUARD_HEADER_DATA, payload: systemGuardData });
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  } catch (err) {
    console.log(err);
    if (loc === "dashboard") {
      yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
    }
  }
}

function* fetchSysGuardDatasource(action) {
  const type = action.payload;
  let options = {
    method: "GET",
    url: getDatasourceWithType(type),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const data = res?.data;
      yield put({
        type: SET_SYS_GUARD_DATASOURCE,
        payload: data,
        source: type,
      });
    }
  } catch (err) {
    console.log(err);
  }
}

function* fetchAllSysGuardDataSources() {
  let options = {
    method: "GET",
    url: getAllSysGuardDataSources(),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const data = res?.data;
      yield put({
        type: SET_ALL_SYS_GUARD_DATASOURCES,
        payload: data,
      });
    }
  } catch (err) {
    console.log(err);
  }
}

function* getSysGuardUsersExpandedData() {
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });
  const cubejs = getCubejsApi();
  const { selectedDatasourceID } = yield select((state) => state.SysGuardReducer);
  const userChartQuery = {
    dimensions: ["SysguardUserChart.name", "SysguardUserChart.alertCount"],
    order: {
      "SysguardUserChart.username": "asc",
    },
    limit: 500,
    filters: [
      {
        member: "SysguardUserChart.datasourceId",
        operator: "equals",
        values: selectedDatasourceID,
      },
    ],
  };

  try {
    const userData = yield cubejs.load(userChartQuery);
    const userChart = userData.rawData();
    const { heatmapData, heatmapDetails } = generateHeatmapData(
      userChart,
      heatmapExpanded,
      "SysguardUserChart.alertCount",
      "SysguardUserChart.name"
    );
    const expandedUserChartData = {
      userChart: { heatmapData, heatmapDetails },
    };
    yield put({
      type: SET_EXPANDED_USERS_DASHBOARD_DATA,
      payload: expandedUserChartData,
    });
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  } catch (err) {
    console.log(err);
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  }
}

function* getSysGuardUsers(action) {
  yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: true });
  const {
    id,
    currentPage,
    pageSize,
    isIncognito,
    userFields,
    MFAFields,
    RiskFactorFields,
  } = action.payload;
  const sysData = yield select((state) => state.SysGuardReducer);
  const { fromTimeStamp, toTimeStamp } = sysData;

  let userName = "";
  let MFA = "";
  let RiskFactor = "";
  let paramData = {};
  const MFAdata = {
    YES: "true",
    NO: "false",
  };
  const riskData = {
    High: "HIGH",
    Medium: "MEDIUM",
    Low: "LOW",
    "No Risk": "NONE",
  };

  if (userFields && userFields.length > 0) {
    userFields.forEach((each) => {
      userName = userName + `${each},`;
    });
    userName = userName.slice(0, -1);
    paramData.userNames = userName;
  }
  if (MFAFields && MFAFields.length > 0) {
    MFAFields.forEach((each) => {
      MFA = MFA + `${each},`;
    });
    MFA = MFA.slice(0, -1);
    paramData.mfa = MFAdata[MFA];
  }
  if (RiskFactorFields && RiskFactorFields.length > 0) {
    RiskFactorFields.forEach((each) => {
      RiskFactor = RiskFactor + `${each},`;
    });
    RiskFactor = RiskFactor.slice(0, -1);
    paramData.userRisk = riskData[RiskFactor];
  }

  const options = {
    method: "GET",
    url: fetchSysGuardUsersAPI(
      fromTimeStamp,
      toTimeStamp,
      id,
      currentPage,
      pageSize
    ),
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      let data = res?.data?.content || [];
      data = data.map((user, index) => ({
        ...user,
        id: index,
      }));
      // Mask username if incognito mode is enabled
      if (isIncognito) {
        data = data.map((user) => ({
          ...user,
          userName: maskUsername(user.userName),
        }));
      }
      const totalElements = res?.data?.totalElements;
      yield put({ type: SET_TOTAL_ELEMENTS, payload: totalElements });
      yield put({ type: SET_SYS_GUARD_TABLE_DATA, payload: data });
      yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err, "error");
    yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: false });
  }
}

function* getSysGuardLocation(action) {
  yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: true });
  const { id, currentPage, pageSize, countryNames, threatFields } =
    action.payload;
  const sysData = yield select((state) => state.SysGuardReducer);
  const { fromTimeStamp, toTimeStamp } = sysData;
  let country = "";
  let threats = "";
  let paramData = {};

  if (countryNames && countryNames.length > 0) {
    countryNames.forEach((each) => {
      country = country + `${each},`;
    });
    country = country.slice(0, -1);
    paramData.countryNames = country;
  }
  if (threatFields && threatFields.length > 0) {
    threatFields.forEach((each) => {
      threats = threats + `${each},`;
    });
    threats = threats.slice(0, -1);
    paramData.threats = threats;
  }

  const options = {
    method: "GET",
    url: fetchSysGuardLocationData(
      fromTimeStamp,
      toTimeStamp,
      id,
      currentPage,
      pageSize
    ),
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const rawData = res?.data?.content;
      const dataWithIds = rawData.map((item, index) => ({
        ...item,
        id: index, // ← add array index as `id`
      }));
      const totalElements = res?.data?.totalElements;
      yield put({ type: SET_TOTAL_ELEMENTS, payload: totalElements });
      yield put({ type: SET_SYS_GUARD_TABLE_DATA, payload: dataWithIds });
      yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err, "error");
    yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: false });
  }
}

function* getSysGuardApplication(action) {
  yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: true });
  const { id, currentPage, pageSize, applicationName, countryNames } =
    action.payload;
  const sysData = yield select((state) => state.SysGuardReducer);
  const { fromTimeStamp, toTimeStamp } = sysData;
  let app = "";
  let country = "";
  let paramData = {};
  if (applicationName && applicationName.length > 0) {
    applicationName.forEach((each) => {
      app = app + `${each},`;
    });
    app = app.slice(0, -1);
    paramData.appNames = app;
  }
  if (countryNames && countryNames.length > 0) {
    countryNames.forEach((each) => {
      country = country + `${each},`;
    });
    country = country.slice(0, -1);
    paramData.countryNames = country;
  }
  const options = {
    method: "GET",
    url: fetchSysGuardApplicationAPI(
      fromTimeStamp,
      toTimeStamp,
      id,
      pageSize,
      currentPage
    ),
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const rawData = res?.data?.content;
      const dataWithIds = rawData.map((item, index) => ({
        ...item,
        id: index, // ← add array index as `id`
      }));
      const totalElements = res?.data?.totalElements;
      yield put({ type: SET_TOTAL_ELEMENTS, payload: totalElements });
      yield put({ type: SET_SYS_GUARD_TABLE_DATA, payload: dataWithIds });
      yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err, "error");
    yield put({ type: SET_SYS_GUARD_TABLE_LOADER, payload: false });
  }
}

function* getSysGuardPopupData(action) {
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });

  const {
    dataSourceId,
    actorId,
    currentPage,
    pageSize,
    loc,
    country,
    application,
  } = action.payload;
  const { fromTimeStamp, toTimeStamp } = yield select(
    (state) => state.SysGuardReducer
  );

  // Map location to the corresponding API function
  const apiMap = {
    userLocations: fetchSysGuardUserLocationApi,
    userDevices: fetchSysGuardUserDeviceApi,
    totalDevices: fetchSysGuardUserDeviceApi,
    userAnomalies: fetchSysGuardUserAnomaliesApi,
    locationBasedUsers: fetchSysGuardLocationBasedUsers,
    locationBasedAnomalies: fetchSysGuardLocationBasedAnomalies,
    locationBasedApplications: fetchSysGuardLocationBasedApplications,
    applicationBasedUsers: fetchSysGuardApplicationBasedUsers,
    applicationBasedAnomalies: fetchSysGuardApplicationBasedAnomalies,
  };

  // Select the correct API function or default to `fetchSysGuardUserApplicationApi`
  const fetchAPI = apiMap[loc] || fetchSysGuardUserApplicationApi;

  const options = {
    method: "GET",
    url: fetchAPI(
      fromTimeStamp,
      toTimeStamp,
      dataSourceId,
      actorId,
      pageSize,
      currentPage,
      country,
      application
    ),
    headers: getAxiosHeaders(true),
  };

  try {
    const res = yield getService(options);
    if (res?.status === 200) {
      yield put({
        type: SET_SYS_GUARD_POPUP_TOTAL_ELEMENTS,
        payload: res.data?.totalElements,
      });
      yield put({ type: SET_SYS_GUARD_POPUP_DATA, payload: res.data?.content });
    }
  } catch (err) {
    console.error("Error fetching SysGuard Popup Data:", err);
  } finally {
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  }
}

function* getSysGuardSidePopupData(action) {
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });
  const { dataSourceId, actorId, loc, country, application } = action.payload;
  const { fromTimeStamp, toTimeStamp } = yield select(
    (state) => state.SysGuardReducer
  );
  const getLocation = () => {
    if (loc === "userLocations") {
      return "city";
    } else if (loc === "userDevices" || loc === "totalDevices") {
      return "device";
    } else if (loc === "userApplications") {
      return "application";
    }
  };
  const getAPIBasedOnLocation = () => {
    const apiMap = {
      locationBasedAnomalies: () =>
        fetchLocationAnomaliesCount(
          fromTimeStamp,
          toTimeStamp,
          dataSourceId,
          country,
          getLocation()
        ),

      userDevices: () =>
        fetchUserBasedDevicesCount(
          fromTimeStamp,
          toTimeStamp,
          dataSourceId,
          actorId
        ),

      totalDevices: () =>
        fetchUserBasedDevicesCount(
          fromTimeStamp,
          toTimeStamp,
          dataSourceId,
          actorId
        ),

      locationBasedApplications: () =>
        fetchLocationBasedApplications(
          fromTimeStamp,
          toTimeStamp,
          dataSourceId,
          country
        ),

      userAnomalies: () =>
        fetchUserAnomaliesSidePopupData(
          fromTimeStamp,
          toTimeStamp,
          dataSourceId,
          actorId
        ),

      applicationBasedAnomalies: () =>
        fetchApplicationAnomaliesCount(
          fromTimeStamp,
          toTimeStamp,
          dataSourceId,
          application
        ),
      applicationBasedUsers: () =>
        fetchApplicationBasedUserCounts(
          fromTimeStamp,
          toTimeStamp,
          dataSourceId,
          application
        ),
    };

    return apiMap[loc]
      ? apiMap[loc]()
      : fetchSidePopupData(
          fromTimeStamp,
          toTimeStamp,
          dataSourceId,
          actorId,
          getLocation()
        );
  };

  const options = {
    method: "GET",
    url: getAPIBasedOnLocation(),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res?.status === 200) {
      yield put({ type: SET_SYS_GUARD_SIDE_POPUP_DATA, payload: res.data });
    }
  } catch (err) {
    console.log(err, "error");
  } finally {
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  }
}

function* getSysGuardDistinctLocations(action) {
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });
  const { dataSourceId, actorId } = action.payload;
  const { fromTimeStamp, toTimeStamp } = yield select(
    (state) => state.SysGuardReducer
  );

  const options = {
    method: "GET",
    url: fetchSysGuardUserDistinctLocations(
      fromTimeStamp,
      toTimeStamp,
      dataSourceId,
      actorId
    ),
    headers: getAxiosHeaders(true),
  };

  try {
    const res = yield getService(options);
    if (res?.status === 200) {
      const data = res?.data
        .filter(
          (e) =>
            !isNaN(parseFloat(e.latitude)) && !isNaN(parseFloat(e.longitude))
        )
        .map((e) => ({
          position: [parseFloat(e.latitude), parseFloat(e.longitude)],
          label: "",
          category: "",
        }));

      yield put({ type: SET_SYS_GUARD_DISTINCT_LOCATIONS, payload: data });
    }
  } catch (err) {
    console.log(err, "Error");
  } finally {
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  }
}

// Function to fetch city coordinates from OpenStreetMap
const getCityCoordinates = async (city, countryCode) => {
  const url = fetchCityCoordinates(city, countryCode);
  try {
    const response = await fetch(url);
    const data = await response.json();
    if (data.length > 0) {
      return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
    }
  } catch (error) {
    console.error("Geocoding error:", error);
  }
  return null;
};

// Function to process mapData & count unique users per city
const processMapData = async (mapData, countryCode) => {
  const cityUserMap = new Map();
  const unknownCities = [];

  // Iterate over mapData to group users by city & handle unknown cities
  mapData.forEach(({ city, userName, latitude, longitude }) => {
    if (!city || city === "Not Available") {
      // If city is unknown, store it separately with provided lat/lng
      if (
        !isNull(latitude) &&
        !isUndefined(latitude) &&
        !isNull(longitude) &&
        !isUndefined(longitude)
      ) {
        unknownCities.push({
          name: "Unknown",
          users: 1,
          lat: latitude,
          lng: longitude,
        });
      }
    } else {
      // If city exists, store unique users in a Set
      if (!cityUserMap.has(city)) {
        cityUserMap.set(city, new Set());
      }
      cityUserMap.get(city).add(userName);
    }
  });

  // Fetch coordinates for known cities and map user count
  const cityPromises = [...cityUserMap.entries()].map(async ([city, users]) => {
    const coordinates = await getCityCoordinates(city, countryCode);
    return coordinates
      ? {
          name: city,
          users: users.size, // Unique user count per city
          lat: coordinates.lat,
          lng: coordinates.lng,
        }
      : null;
  });

  // Resolve all city coordinate fetches and filter out invalid ones
  const processedCities = (await Promise.all(cityPromises)).filter(Boolean);

  // Combine known and unknown city data
  return [...processedCities, ...unknownCities];
};

function* fetchCityDataSaga(action) {
  try {
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });
    const processedCities = yield call(
      processMapData,
      action.payload.mapData,
      action.payload.countryCode
    );
    // Find the city with the highest number of users
    // We use .reduce() to iterate over the array and keep track of the city with the most users.
    // If the array is empty, we return null.
    const highestCity = processedCities.length
      ? processedCities.reduce((prev, curr) =>
          curr.users > prev.users ? curr : prev
        )
      : null;
    yield put({
      type: SET_SYS_GUARD_CITY_DATA,
      payload: {
        cities: processedCities,
        mapCenter: highestCity ? [highestCity.lat, highestCity.lng] : null,
      },
    });
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  } catch (error) {
    console.error("Error fetching city data:", error);
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  }
}

function* saveSysGuardAlertComment(action) {
  const { id, comment } = action.payload;
  let commentData = {
    comments: `${comment}`,
  };
  const options = {
    method: "POST",
    url: `${SAVE_ALERT_COMMENT_URL}/${id}/comments`,
    headers: getAxiosHeaders(true),
    data: commentData,
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 201) {
      yield put({ type: SET_SYS_GUARD_ALERT_COMMENT, payload: null });
    }
  } catch (err) {
    console.log(err);
  }
}

function* createJiraIncident(action) {
  yield put({ type: SET_ALERT_DRAWER_PAGE_LOADER, payload: true });

  const { alerts, isCompliance } = action.payload;
  const results = [];
  let allSuccessful = true;

  try {
    for (const { alertId, dataSourceID } of alerts) {
      const options = {
        method: "POST",
        url: reportToJira(alertId, dataSourceID),
        headers: getAxiosHeaders(true),
      };

      const res = yield call(getService, options);

      if (res && res.status === 200) {
        results.push(res.data);
      } else {
        allSuccessful = false;
        yield put({ type: REPORT_INCIDENT_FAILED });
        yield put({ type: OPEN_SYS_GUARD_SNACKBAR, payload: true });
      }
    }

    if (allSuccessful) {
      yield put({ type: REPORT_INCIDENT_SUCCESSFUL });
      yield put({ type: OPEN_SYS_GUARD_SNACKBAR, payload: true });
      if (isCompliance) {
        const selectedSiteFromStore = yield select(
          (state) => state.ComplianceReducer.selectedSite
        );
        yield put({
          type: GET_COMPLIANCE_STATE_DATA,
          payload: { selectedSite: selectedSiteFromStore },
        });
      }
    }

    yield put({ type: SET_REPORT_INCIDENT_DETAILS, payload: results });
  } catch (err) {
    console.error("Error in createJiraIncident saga:", err);
    yield put({ type: REPORT_INCIDENT_FAILED });
    yield put({ type: OPEN_SYS_GUARD_SNACKBAR, payload: true });
  } finally {
    yield put({ type: SET_ALERT_DRAWER_PAGE_LOADER, payload: false });
  }
}

function* applicationNamesList(action) {
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });
  const { dataSourceId, fromTimeStamp, toTimeStamp } = action.payload;
  const dataSet = "distinctApplications";
  const options = {
    method: "GET",
    url: getSysGuardApplicationNames(
      dataSourceId,
      fromTimeStamp,
      toTimeStamp,
      dataSet
    ),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const data = res?.data;
      yield put({
        type: SET_SYS_GUARD_APPLICATION_NAMES,
        payload: data,
      });
    }
  } catch (err) {
    console.log(err);
    redirectToLogin(err);
  } finally {
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  }
}

function* countryNameList(action) {
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });
  const { dataSourceId, fromTimeStamp, toTimeStamp } = action.payload;
  const dataSet = "distinctCountries";
  const options = {
    method: "GET",
    url: getSysGuardApplicationNames(
      dataSourceId,
      fromTimeStamp,
      toTimeStamp,
      dataSet
    ),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const data = res?.data;
      yield put({
        type: SET_SYS_GUARD_COUNTRY_NAMES,
        payload: data,
      });
    }
  } catch (err) {
    console.log(err);
    redirectToLogin(err);
  } finally {
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  }
}

function* getUniqueUserNameList(action) {
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true });
  const { dataSourceId } = action.payload;
  const options = {
    method: "GET",
    url: getUniqueUsersList(dataSourceId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      let data = res?.data;
      yield put({
        type: SET_UNIQUE_USER_LIST,
        payload: data,
      });
    }
  } catch (err) {
    console.log(err);
    redirectToLogin(err);
  } finally {
    yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false });
  }
}

function* fetchChatBotData(action) {
  const { query } = action.payload;
  yield put({ type: SET_CHATBOT_LOADER, payload: true });

  const options = {
    method: "POST",
    url: getChatbotResponseAPI(),
    headers: getAxiosHeaders(true),
    data: { query: query, max_results: 50 },
  };

  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      const data = res?.data;
      yield put({ type: SET_CHATBOT_RESPONSE, payload: data });
    } else {
      yield put({ type: SET_CHATBOT_RESPONSE, payload: { query_results: [] } });
    }
  } catch (err) {
    console.log(err);
    redirectToLogin(err);
  } finally {
    yield put({ type: SET_CHATBOT_LOADER, payload: false });
  }
}

function* saveChatBoatChat(action) {
  try {
    const formData = new FormData();

    const jsonBlob = new Blob([action.payload.jsonString], {
      type: "application/json",
    });

    formData.append("file", jsonBlob, "chatLogs.json");

    const options = {
      method: "POST",
      url: saveChatBotAPI,
      data: formData,
      headers: getAxiosHeaders(true),
    };

    const res = yield getService(options);

    if (res && res.status === 200) {
      console.log("Chat Saved");
    } else {
      console.warn("Unexpected response", res);
    }
  } catch (err) {
    console.error("Failed to save chat:", err);
  }
}


function* SysGuardSaga() {
  yield takeEvery(FETCH_SYS_GUARD_DATA_SOURCE, fetchSysGuardDatasource);
  yield takeEvery(FETCH_ALL_SYS_GUARD_DATA_SOURCES, fetchAllSysGuardDataSources);
  yield takeEvery(GET_SYS_GUARD_USERS, getSysGuardUsers);
  yield takeEvery(GET_SYS_GUARD_LOCATION, getSysGuardLocation);
  yield takeEvery(GET_SYS_GUARD_APPLICATION, getSysGuardApplication);
  yield takeEvery(GET_SYS_GUARD_HEADER_DATA, fetchSysGuardHeaderData);
  yield takeEvery(GET_SYS_GUARD_POPUP_DATA, getSysGuardPopupData);
  yield takeEvery(GET_SYS_GUARD_SIDE_POPUP_DATA, getSysGuardSidePopupData);
  yield takeEvery(
    GET_SYS_GUARD_DISTINCT_LOCATIONS,
    getSysGuardDistinctLocations
  );
  yield takeEvery(GET_SYS_GUARD_CITY_DATA, fetchCityDataSaga);
  yield takeEvery(
    GET_EXPANDED_USERS_DASHBOARD_DATA,
    getSysGuardUsersExpandedData
  );
  yield takeEvery(SAVE_SYS_GUARD_COMMENT, saveSysGuardAlertComment);
  yield takeEvery(CREATE_JIRA_INCIDENT, createJiraIncident);
  yield takeEvery(SYS_GUARD_APPLICATION_NAMES_LIST, applicationNamesList);
  yield takeEvery(SYS_GUARD_COUNTRIES_LIST, countryNameList);
  yield takeEvery(GET_UNIQUE_USER_LIST, getUniqueUserNameList);
  yield takeEvery(FETCH_CHATBOT_RESPONSE, fetchChatBotData);
  yield takeEvery(SAVE_CHAT_BOT_CHAT, saveChatBoatChat);
}

export default SysGuardSaga;
